import styled from "styled-components";

export const SwitchFormFieldStyle = styled.div<{ disabled?: boolean, hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;

  .switch-label {
    font-size: 14px;
    font-weight: 500;
    color: ${({ disabled }) => (disabled ? "#B9BEC7" : "#2B3952")};
  }

  .MuiSwitch-root {
    width: 42px;
    height: 26px;
    padding: 0;
  }

  .MuiSwitch-switchBase {
    padding: 1px;
    &.Mui-checked {
      transform: translateX(16px);
      color: #fff;

      + .MuiSwitch-track {
        background-color: var(--royal-blue-color);
        opacity: 1;
        border: 0;
      }
    }
  }

  .MuiSwitch-thumb {
    width: 24px;
    height: 24px;
    box-shadow: none;
  }

  .MuiSwitch-track {
    border-radius: 13px;
    background-color: #B9BEC7;
    opacity: 1;
    transition: background-color 0.3s ease;
  }

  .Mui-disabled {
    opacity: 0.6;
  }
  .helper-text {
    font-size: 12px;
    color: ${({ hasError }) => (hasError ? "#EB0000" : "#667085")};
  }
`;
